/**
 * Meta (Facebook) Pixel. Tells Meta which ad visitors got a preview and who
 * bought, so the campaign can look for more people like them.
 *
 * Only standard events and the price go to Meta. Never a name, email,
 * birth detail, request ID or report text.
 *
 * Off unless REACT_APP_META_PIXEL_ID is set at build time.
 */

const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || "").trim();
const SENT_KEY = "ayupath-pixel-sent";
const REPORT_PRICE = { value: 49, currency: "AUD" };

// Our funnel event -> Meta standard event. once: per browser, so revisits
// from an email or a page refresh don't count twice.
const EVENT_MAP = {
  teaser_view: { name: "Lead", once: "requestId" },
  checkout_started: { name: "InitiateCheckout", params: REPORT_PRICE },
  purchase_confirmed: { name: "Purchase", params: REPORT_PRICE, once: "session" },
};

export function pixelEnabled() {
  return /^\d{6,20}$/.test(PIXEL_ID);
}

/** Meta's standard loader, kept as close to the official snippet as possible. */
export function initMetaPixel() {
  if (typeof window === "undefined" || !pixelEnabled() || window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

function alreadySent(key) {
  try {
    const sent = JSON.parse(localStorage.getItem(SENT_KEY) || "[]");
    if (sent.includes(key)) return true;
    localStorage.setItem(SENT_KEY, JSON.stringify([...sent, key].slice(-50)));
  } catch {
    // Storage blocked: send anyway.
  }
  return false;
}

function onceKey(rule, event, payload) {
  if (rule.once === "requestId") return payload.requestId ? `${event}:${payload.requestId}` : null;
  if (rule.once === "session") {
    try {
      return `${event}:${sessionStorage.getItem("ayupath-session") || ""}`;
    } catch {
      return null;
    }
  }
  return null;
}

/** Called from track() for every funnel event; ignores the ones Meta doesn't need. */
export function forwardToPixel(event, payload = {}) {
  const rule = EVENT_MAP[event];
  if (!rule || typeof window === "undefined" || typeof window.fbq !== "function") return;
  const key = onceKey(rule, event, payload);
  if (key && alreadySent(key)) return;
  window.fbq("track", rule.name, rule.params ? { ...rule.params } : {});
}
